import { FC } from "react";
import Card, { ICard } from "components/molecules/card/Card";
import { CardType } from "lib/helpers/constants/cardTypes";
import { IInfoCardProps } from "components/molecules/card/info-card/InfoCard";
import { JSX } from "react/jsx-runtime";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useThemeContext } from "lib/context/ThemeContext/ThemeContext";
import { useTranslation } from "react-i18next";
import { useCustomersPendingsStatisticCardsData } from "lib/hooks/queries/Pendings/useCustomersPendingsStatisticCardsData";

export interface IProps {
}

const PendingCards: FC<IProps> = () => {
  const {themeColors} = useThemeContext();
  const {data} = useCustomersPendingsStatisticCardsData();
  const {t} = useTranslation();


  const cardsData = [
    {
      title: `${t("Total Pendings")}`,
      color: themeColors.primary,
      count: data?.totalPendings,
      icon: IconType.PENDINGS_ICON,
      updatedate: new Date().toLocaleDateString('de'),
    },
    {
      title: `${t("Open Pendings")}`,
      color: themeColors.primary,
      count: data?.openPendings,
      icon: IconType.OPEN_PENDINGS_ICON,
      updatedate: new Date().toLocaleDateString('de'),
   
    },
    {
      title: `${t("Processing Pendings")}`,
      count: data?.processing,
      color: themeColors.primary,
      icon: IconType.PROCESSING_PENDINGS_ICON,
      updatedate: new Date().toLocaleDateString('de'),
    
    },
    {
      title: `${t("Done Pendings")}`,
      count: data?.done,
      color: themeColors.primary,
      icon: IconType.DONE_PENDING_ICON,
      updatedate: new Date().toLocaleDateString('de'),

    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-4 2xl:grid-cols-4 items-center justify-between gap-5">
      {cardsData?.map(
        (
          item: JSX.IntrinsicAttributes & ICard<IInfoCardProps>,
          index: number
        ) => (
          <Card<IInfoCardProps>
            cardType={CardType.INFO_CARD}
            {...item}
            key={`leads-cards-key-${index}`}
          />
        )
      )}
    </div>
  );
};

export default PendingCards;
